<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">编号</div>
          <div class="field">
            <el-input v-model="query.syscode" :maxlength="20" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">名称</div>
          <div class="field">
            <el-input v-model="query.syscodename" :maxlength="20" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">备注</div>
          <div class="field">
            <el-input v-model="query.syscoderemark" :maxlength="20" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
            :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="false" :needPopMenu="true" :canbeEdit="true" :editRules="editRules"
            @cellClick="cellClick" @pagechange="pagechange"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  const SUCCESS = 1
  const valid = (cellValue, row, field,  msg,) => {
    return new Promise((resolve, reject)=> {
      request({
          url: '/validate/validateData',
          method: "post",
          data: {tablename: 'syscoderec',checkfield: field, checkval: cellValue, id: row.syscodeid, fieldid: 'syscodeid'}
        }).then (res => {
          res === SUCCESS ? reject(Error(msg)) : resolve()
      })
    })
  }
  export default {
    name: 'syscodeIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'syscode', fieldtype: 'C', title: '编号',calculExpr:'', editRender: { name: 'input'}},
          { field: 'syscodename', fieldtype: 'C', title: '名称',calculExpr:'',editRender: { name: 'input'}},
          { field: 'syscodeseq', fieldtype: 'N', title: '顺序号',calculExpr:'',editRender: { name: 'input'}},
          { field: 'syscodeval', fieldtype: 'C', title: '值',calculExpr:'',editRender: { name: 'input'}},
          { field: 'syscodeishide', fieldtype: 'C', title: '显示/隐藏',syscode: 'syscodeishide', calculExpr:'',editRender: { name: 'select', options: []}},
          { field: 'syscoderemark', fieldtype: 'C',title: '备注',calculExpr:'',editRender: { name: 'input'}},
          { field: 'syscodeid', fieldtype: 'C', visible: false}
        ],
        editRules: {
          'syscode': [{required: true, message: '输入不能为空'},
          {validator: ({ cellValue, rule, rules, row, rowIndex, column, columnIndex }) => {
            return valid(cellValue, row, 'syscode', '编号不能重复')
          }, trigger: 'blur'}],
          'syscodename': [{required: true, message: '输入不能为空'},
          {validator: ({ cellValue, rule, rules, row, rowIndex, column, columnIndex }) => {
            return valid(cellValue, row, 'syscodename', '名称不能重复')
          }, trigger: 'blur'}],
          'syscodeseq': [{required: true, message: '输入不能为空'}],
          'syscodeval': [{required: true, message: '输入不能为空'}]
        },
        syscode: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('SAV', () => this.addOrEdit())
      this.$on('DEL', () => this.delSysCode())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getSysCodeList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.syscode = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async delSysCode () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/syscode/delSysCode',
            method: "post",
            data: this.syscode
          })
          if (data.issuccess===1) {
            this.getSysCodeList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
      search () {
        this.query.offset = 0
        this.getSysCodeList()
      },
      async cellClick (row) {
        this.syscode = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getSysCodeList()
      },
      async addOrEdit () {
        let model = this.$refs.xGrid.$refs.xGrid.getRecordset()
        let data = await request({
          url: '/kfgl/syscode/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          await this.getSysCodeList()
          this.$message.success('保存成功！')
        } else {
          this.$message.error('保存失败!')
        }
      },
      async getSysCodeList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/syscode/findAll',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
